// Handle tab click event
$(".tab-menu li a").on("click", function () {
  var target = $(this).attr("data-rel");
  
  $(".tab-menu li a").removeClass("active");   // Remove 'active' class from all tabs

  $(this).addClass("active");   // Add 'active' class to the clicked tab

  // Show the related tab content and hide others
  $("#" + target)
    .fadeIn("slow")
    .siblings(".tab-box")
    .hide();
  
  return false; // Prevent default link behavior
});

$(document).ready(function () {
  $(".tab-menu li a").first().click();  // Trigger a click on the first tab to set it as active
});


if (window.location.pathname === '/collections/all') {
    $('.collections-title').addClass('show');
}